/**
 * CategoryGroup - Grupo de items por categoria
 *
 * Agrupa items visualmente con iconos representativos
 * para facilitar el escaneo rapido (ADHD-friendly)
 */

import { AnimatePresence } from 'framer-motion';
import {
  Heart,
  User,
  Smartphone,
  Droplets,
  Shirt,
  Briefcase,
  MoreHorizontal,
} from 'lucide-react';
import type { ChecklistItem, ItemCategory } from '@/core/types';
import { ChecklistItemRow } from './ChecklistItemRow';

const CATEGORY_ICONS: Record<ItemCategory, typeof Heart> = {
  health: Heart,
  personal: User,
  tech: Smartphone,
  hygiene: Droplets,
  clothing: Shirt,
  work: Briefcase,
  other: MoreHorizontal,
};

interface CategoryGroupProps {
  category: ItemCategory;
  label: string;
  items: ChecklistItem[];
  checklistId: string;
}

export function CategoryGroup({
  category,
  label,
  items,
  checklistId,
}: CategoryGroupProps) {
  const Icon = CATEGORY_ICONS[category];

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 px-1">
        <Icon className="w-4 h-4 text-slate-500" />
        <h3 className="text-xs font-medium text-slate-500 uppercase tracking-wide">
          {label}
        </h3>
      </div>

      <div className="space-y-1">
        <AnimatePresence>
          {items.map((item) => (
            <ChecklistItemRow
              key={item.id}
              item={item}
              checklistId={checklistId}
            />
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
